export default __webpack_public_path__ + "static/media/prev-elevateswarovski.111e5f04.jpg";